import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {IHistoryRecordAmountViewModel} from "../../../../services/gaming-history/models/record/history-record-view-model.interface";
import {HistoryRecordAmountBox} from "./boxes/end-section/amounts/history-record-amount.box";
import {HistoryRecordAmountDescriptionBox} from "./boxes/end-section/amounts/history-record-amount-description.box";
import {HistoryRecordAmountValueBox} from "./boxes/end-section/amounts/history-record-amount-value.box";
import React from "react";
import {CyClass} from "../../../../../common/cy-classes";
import {observer} from "mobx-react";

interface GamingHistoryRecordAmountComponentProps {
    amount: IHistoryRecordAmountViewModel;
}

export const GamingHistoryRecordAmountComponent = observer(
    class GamingHistoryRecordAmountComponent extends OrbitComponent<GamingHistoryRecordAmountComponentProps> {
        render() {
            return (
                <HistoryRecordAmountBox className={this.props.amount.cyClass}>
                    <HistoryRecordAmountDescriptionBox className={CyClass('cy-gaming-history-amount-description')}>
                        {this.props.amount.description}
                    </HistoryRecordAmountDescriptionBox>
                    <HistoryRecordAmountValueBox className={CyClass('cy-gaming-history-amount-value')}>
                        {this.props.amount.value}
                    </HistoryRecordAmountValueBox>
                </HistoryRecordAmountBox>

            );
        }
    }
);